import illi1 from './illi1.png'
import illi2 from './illi2.png'
import illi3 from './illi3.png'
import illi4 from './illi4.png'
import illi5 from './illi5.png'
import illi6 from './illi6.png'
import illi7 from './illi7.png'
import illi8 from './illi8.png'
import illi9 from './illi9.png'
import illi10 from './illi10.png'
import illi11 from './illi11.png'

const illustrative = [
    illi1,
    illi2,
    illi3,
    illi4,
    illi5,
    illi6,
    illi7,
    illi8,
    illi9,
    illi10,
    illi11
]

export default illustrative
